<div class="site-gutter">
    <div class="image-banner">
        @if (simpleImage) {
            <img src="{{imgUrl}}" alt="">
        } @else {
            <picture>
                <source srcset="{{imgUrl}}-d.webp, {{imgUrl}}-d@2x.webp 2x" media="(min-width: 600px)" />
                <source srcset="{{imgUrl}}-m.webp, {{imgUrl}}-m@2x.webp 2x" />
                <img class="article-hero" src="{{imgUrl}}-m.webp" />
            </picture>
        }
    </div>
</div>